import { toast } from '@/components/toast';
import { updateTranslation, UpdateTranslationPayload } from '@/services/api';
import { logger } from '@/services/logger';
import { ITranslation } from '@d-id/types';
import { useMutation, useQueryClient } from 'react-query';
import { GET_TRANSLATION_GROUP_KEY } from './translationLibrary';

export const useUpdateTranslation = () => {
    const queryClient = useQueryClient();

    return useMutation(
        async (payload: UpdateTranslationPayload & { id: string }) => {
            const { id, ...variables } = payload;
            return updateTranslation(id, variables);
        },
        {
            onError: (err: any) => {
                logger.error(`Could not update translation`, { err });
                toast.error({ title: `Could not update video`, toastId: `library-item-update-error` });
            },
            onSuccess: async ({ group_id }: ITranslation) => {
                await queryClient.invalidateQueries([GET_TRANSLATION_GROUP_KEY, group_id]);
            },
        }
    );
};
